module.exports = __webpack_public_path__ + "assets/4f6c62aadf3c26dbafdcc2af95ad9188.svg";